module.exports = __webpack_public_path__ + "img/reletionship.5b8f70b9.svg";